"use client";

import type { PortalFaq } from "@/actions/faq/fetchPortalFaqs";
import { TitleH2 } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import FaqHolder from "./FaqHolder";

const FaQs = ({
  managedFaqs = [],
  publicFaqsUrl = "/api/public/faqs",
}: {
  managedFaqs?: PortalFaq[];
  publicFaqsUrl?: string;
}) => {
  const t = useTranslations("faq");
  const [faqItems, setFaqItems] = useState(managedFaqs);

  useEffect(() => {
    const controller = new AbortController();

    fetch(publicFaqsUrl, {
      headers: { Accept: "application/json" },
      signal: controller.signal,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        if (Array.isArray(payload?.data)) {
          setFaqItems(payload.data);
        }
      })
      .catch((error) => {
        if (error instanceof Error && error.name !== "AbortError") {
          console.error("[FaQs]", error);
        }
      });

    return () => controller.abort();
  }, [publicFaqsUrl]);

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-5">
          <TitleH2 title={t("title")} />
          <p className="text-ring">{t("text")}</p>
        </div>

        {/* FAQ`S */}
        <FaqHolder managedFaqs={faqItems} />
      </div>
    </div>
  );
};

export default FaQs;
